import { coreInstance, konjInstance } from "api";

const getKonjUserInfo = async () => {
  const { data } = await coreInstance.get(
    `/api/common/v1/Dispatcher/Konj/ExchangeTokenUser`
  );
  return data.data;
};
const getStudentInfo = async ({ schoolId, semesterId, studentId }) => {
  const { data } = await coreInstance.get(
    `/api/teacher/v1/Student/${schoolId}/${semesterId}/Profile/${studentId}`
  );
  return data.data;
};
const syncKonjUser = async (externalToken) => {
  const { data } = await coreInstance.get(
    `/api/common/v1/Dispatcher/Konj/SyncUser`,
    {
      params: {
        externalToken,
      },
    }
  );
  return data;
};
const generateExternalKonjToken = async () => {
  const { data } = await konjInstance.get(`/gen-ext-token/`);
  return data.data;
};

const importKonjUser = async ({ body, tokenKonj }) => {
  const { data } = await coreInstance.post(
    `/api/common/v1/Dispatcher/Konj/ImportUser`,
    body,
    {
      headers: {
        tokenKonj: `token ${tokenKonj}`,
      },
    }
  );
  return data;
};

export {
  getKonjUserInfo,
  syncKonjUser,
  importKonjUser,
  generateExternalKonjToken,
  getStudentInfo,
};
